import CascadeTrace from '../components/evolution/CascadeTrace';

export default function Cascade() {
  return <CascadeTrace />;
}
